import { UserRole } from 'dy-frontend-http-repository/lib/data/enums';
import { useStore } from 'effector-react';
import React, { HTMLAttributes } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import PageTabs from '@app/components/PageTabs';
import ALLOWED_REPORTS_ROLES from '@pages/CoreUser/pages/CoreUserReports/consts/allowedReportsRoles';
import { $authorizedUser, $permissions } from '@containers/store/states';
import { Endpoints } from '@data/consts';

import { tabs } from './consts';

type Props = HTMLAttributes<HTMLDivElement>;

const timeTrackingFullAccessRoles = [
    UserRole.CORE_ROOT,
    UserRole.CORE_ADMIN,
    UserRole.CORE_PLATFORM_DEV,
    UserRole.CORE_OPERATIONS_MANAGER,
    UserRole.CORE_ACCOUNT_DIRECTOR,
    UserRole.CORE_CREATIVE_DIRECTOR,
    UserRole.CORE_HR,
];

const Tabs: React.FC<Props> = (props) => {
    const permissions = useStore($permissions);
    const me = useStore($authorizedUser);

    const { coreUserId } = useParams();
    const { pathname } = useLocation();
    const navigate = useNavigate();

    const getFormattedPath = (path: string) => {
        return path.replace(':coreUserId', coreUserId!);
    };

    // List of skipped tab router
    const ignoreTabRoutes: string[] = [];

    // Auth: task
    if (!permissions.isEnabled.task) {
        ignoreTabRoutes.push(Endpoints.CORE_USER_TASK_FEEDBACK);
    }

    // Time tracking
    if (!(timeTrackingFullAccessRoles.includes(me?.user.role) || me?.user.id === coreUserId)) {
        ignoreTabRoutes.push(Endpoints.CORE_USER_TASK_TIME_TRACKING);
    }

    // Reports: visible only to the allowed roles of the signed-in user.
    if (!ALLOWED_REPORTS_ROLES.includes(me?.user.role)) {
        ignoreTabRoutes.push(Endpoints.CORE_USER_REPORTS);
    }

    const collectedTabs = tabs.filter((tab) => !ignoreTabRoutes.includes(tab.value));

    return (
        <PageTabs
            pathname={pathname}
            visibleAmount={7}
            tabs={collectedTabs}
            onSelectTab={navigate}
            pathFormatter={getFormattedPath}
            {...props}
        />
    );
};

export default Tabs;
